module.exports = __webpack_public_path__ + "static/img/5-5.739bd8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/5-5.png
// module id = 276
// module chunks = 0